// @flow
import React from 'react'
import deStrings from './locales/de.yml'
import frStrings from './locales/fr.yml'

type Props = {
  locale: string,
  status: string
}

const MESSAGES = {
  de: deStrings,
  fr: frStrings
}

/**
 * Display an error message, explaining why an article couldn't be loaded.
 * @param [locale=de] The language to show the message in.
 * @param status The HTTP status code describing the error.
 */
export const FetchErrorMessage = ({ locale = 'de', status }: Props) => (
  <div className='ui error icon message'>
    <i className='icon'>🤖</i>
    <div className='content'>
      <div className='header'>{MESSAGES[locale].TITLE}</div>
      <p>{MESSAGES[locale][status] || MESSAGES[locale].DEFAULT}</p>
    </div>
  </div>
)
